import { c as _c } from "react/compiler-runtime";
import { PageSection } from "@components/page-section/page-section";
import { Grid } from "@mui-wrapper";
/** The base settings page component that handles very basic styling and UI for the given PageSectionProps */
export function BaseSettingsPage(t0) {
  const $ = _c(8);
  const {
    pageSectionProps,
    isLoading: t1,
    isCompact: t2,
    dataTestId,
    customSx
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const isCompact = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== customSx || $[1] !== dataTestId || $[2] !== isCompact || $[3] !== isLoading || $[4] !== pageSectionProps) {
    const filteredPageSectionProps = pageSectionProps.filter(_temp);
    let t4;
    if ($[6] !== customSx) {
      t4 = {
        ...customSx
      };
      $[6] = customSx;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = <Grid data-testid={dataTestId} sx={t4}>{filteredPageSectionProps.map((sectionProps, index) => <PageSection key={`settings-section-wrapper-${index}`} isLoading={isLoading} isTopSection={index === 0} isLastSection={index === filteredPageSectionProps.length - 1} isCompact={isCompact} {...sectionProps} />)}</Grid>;
    $[0] = customSx;
    $[1] = dataTestId;
    $[2] = isCompact;
    $[3] = isLoading;
    $[4] = pageSectionProps;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(pageSectionProps_0) {
  return !pageSectionProps_0.isHidden;
}